import noop from 'lodash/noop';
import { rgba } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { red80, slate40 } from '@zocdoc-mezzanine/foundations-colors';

/**
 * @param {string} className
 * @param {JSX.Element} children
 * @param {boolean} showNotice
 * @param {boolean} isError
 * @param {function(): void} onClick
 * @returns {JSX.Element|null}
 * @constructor
 */
const Notice = ({
    className,
    children,
    showNotice,
    isError,
    onClick = noop,
}) => {
    if (!showNotice) return null;

    return (
        <Text
            className={className}
            clickable={onClick !== noop}
            data-test="notice"
            hasError={isError}
            onClick={onClick}
        >
            {children}
        </Text>
    );
};

const Text = styled.div`
    background-color: ${(p) => (p.hasError ? '#FFECF1' : 'transparent')};
    border: solid 1px ${(p) => (p.hasError ? red80 : rgba(slate40, 0.5))};
    font: 15px/24px ${FontFamily.SharpSansMedium};
    padding: 8px 16px;
    margin-top: 8px;
    ${(p) =>
        p.clickable &&
        css`
            cursor: pointer;
        `}
`;

export default Notice;
